import { user as userService } from "@/services";
import { message } from "antd";
export const user = {
  state: { user: undefined, errors: [] }, // initial state
  reducers: {
    updateUser(state, payload) {
      return { ...state, user: { ...payload } };
    },
    logout(state, payload) {
      return { user: undefined };
    },
  },
  effects: (dispatch) => ({
    async login(payload) {
      try {
        const res = await userService.login(payload);
        if (res.status_code === 400) {
          const { status_code, ...rest } = res;
          const messages = Object.values(rest).flat();
          throw new Error(messages.join(", "));
        }
        this.updateUser(res);
        if (res.name) {
          return "/index";
        } else {
          return "/profile";
        }
      } catch (err) {
        message.error(err.message || err);
        return null;
      }
    },
    async updateProfile(payload, rootState) {
      const token = rootState.user.user.token;
      try {
        const res = await userService.updateProfile(payload, token);
        this.updateUser(res);
        return "/index";
      } catch (err) {
        message.error(err.message || err);
        return null;
      }
    },
  }),
};
